import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';
import { tabularPropertiesCommonAdapts } from './tabular-type.dataset.adapter';
import { DataWarehouseTableDataset } from 'shell-models-lib';
import { AzureSqlDWDatasetAdapter } from './azure-sql-dw-table-dataset.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(DataWarehouseTableDataset),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            ...tabularPropertiesCommonAdapts,
            linkedService: '*',
            connectionSettings: __IS_FABRIC_DPE__ ? '*' : undefined,
            typeProperties: {
                tableName: '*',
                schema: '*',
                table: '*'
            }
        }
    }
})
export class DataWarehouseTableDatasetAdapter extends AzureSqlDWDatasetAdapter {
    protected async _toResource(dataset: DataWarehouseTableDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset, Metamodel.modelFor(DataWarehouseTableDataset).name);
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: DataWarehouseTableDataset): Promise<DataWarehouseTableDataset> {
        return await this._toModelInternal(modelDatasetResource, dataset, DataWarehouseTableDataset.MODEL);
    }
}
